import React, { ChangeEvent, FC, useCallback, useRef } from "react";
import moment from "moment";
import ButtonSmall from "../../F7/ButtonSmall";
import { Field } from "../FieldHandler";

const TimeField: FC<{
  field: Field & { type: "time" };
  onChange: (key: string, value: string | undefined) => void;
}> = (props) => {
  const toggleButtonRef = useRef(1);
  const originRef = useRef(props.field.value);
  const lastValueRef = useRef("");

  const autoCompleteTime = !sessionStorage.getItem("autoCompleteTime");
  const shortTimeFormat = !!sessionStorage.getItem("shortTimeFormat");

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const id = props.field.key;
      let value = e.target.value;
      const HH = new RegExp(/^([01]?0\d|1\d|2[0-3])$/);
      const HHMM = new RegExp(/^([01]?0\d|1\d|2[0-3]):[0-5]\d$/);
      if (
        autoCompleteTime &&
        lastValueRef.current.length > 2 &&
        lastValueRef.current.indexOf(":") === lastValueRef.current.length - 1 &&
        value.indexOf(":") === -1
      ) {
        value = value.substr(0, value.length - 1);
      } else if (
        autoCompleteTime &&
        !shortTimeFormat &&
        lastValueRef.current.length > 4 &&
        lastValueRef.current.substr(5, 1).indexOf(":") === 0 &&
        value.substr(5, 1).indexOf(":") !== 0
      ) {
        value = value.substr(0, value.length - 1);
      } else if (autoCompleteTime && value.length > 8) {
        value = value.substr(0, 8);
      } else if (autoCompleteTime && shortTimeFormat && value.length > 5) {
        value = value.substr(0, 5);
      }
      if (autoCompleteTime && shortTimeFormat && value && HH.test(value)) {
        props.onChange(id, (value += ":"));
      } else if (autoCompleteTime && !shortTimeFormat && value && (HHMM.test(value) || (value && HH.test(value)))) {
        lastValueRef.current = value + ":";
        props.onChange(id, (value += ":"));
      } else {
        lastValueRef.current = value;
        props.onChange(id, value);
      }
    },
    [autoCompleteTime, props, shortTimeFormat]
  );

  const handleTimeClick = useCallback(() => {
    const id = props.field.key;
    let value;
    switch (toggleButtonRef.current) {
      case 1:
        value = shortTimeFormat ? moment().format("HH:mm") : moment().format("HH:mm:ss");
        toggleButtonRef.current++;
        break;
      case 2:
        value = shortTimeFormat ? moment().format("HH:00") : moment().format("HH:00:00");
        toggleButtonRef.current++;
        break;
      case 3:
        value = shortTimeFormat ? moment().format("HH:30") : moment().format("HH:30:00");
        toggleButtonRef.current++;
        break;
      case 4:
        value = shortTimeFormat ? moment().add(1, "h").format("HH:00") : moment().add(1, "h").format("HH:00:00");
        toggleButtonRef.current++;
        break;
      case 5:
        if (!originRef.current) {
          value = "";
          toggleButtonRef.current = 1;
          break;
        } else {
          value = originRef.current;
          toggleButtonRef.current++;
          break;
        }
      case 6:
        value = "";
        toggleButtonRef.current = 1;
        break;
      default:
        break;
    }
    props.onChange(id, value);
  }, [props, shortTimeFormat]);

  return (
    <span>
      <div
        style={{
          paddingRight: 40,
        }}
      >
        <input type="text" value={props.field.value || ""} placeholder={props.field.required ? "required" : ""} onChange={handleChange} />
      </div>
      <div
        style={{
          float: "right",
          marginTop: -37,
        }}
      >
        <ButtonSmall onClick={handleTimeClick}>
          <i
            className="fa fa-clock-o"
            style={{
              color: "white",
            }}
          />
        </ButtonSmall>
      </div>
    </span>
  );
};
export default TimeField;
